module.exports = __webpack_public_path__ + "img/6a28590.png";